export default class TransactionCategoryModel {
    constructor() {
        this.name = null;
        this.parent_category_id = null;
        this.type = null;
        this.project_id = null;
    }
}